import { MenuItem, TextField, useMediaQuery } from '@mui/material';
import { breakpoints } from '../../constants';
import { TFormValues } from '../../types';
import { Row } from '../Row';

interface IProps {
    setFieldValue(field: keyof TFormValues, value: string): void;
    formValues: TFormValues;
}

export const NameSection = ({ formValues, setFieldValue }: IProps) => {
    const mediumBreakpoint = useMediaQuery(`(${breakpoints.mediumMin})`);

    return (
        <>
            <TextField
                required
                select
                id="salutation"
                label="Aanhef"
                name="salutation"
                sx={{ maxWidth: '140px' }}
                value={formValues.salutation}
                onChange={(e) => setFieldValue('salutation', e.target.value)}
            >
                <MenuItem value="Dhr.">Dhr.</MenuItem>
                <MenuItem value="Mevr.">Mevr.</MenuItem>
            </TextField>
            <Row>
                <TextField
                    required
                    id="firstName"
                    label="Voornaam"
                    value={formValues.firstName}
                    onChange={(e) => setFieldValue('firstName', e.target.value)}
                />
                <TextField
                    id="lastNamePrefix"
                    label="Tussenvoegsel"
                    sx={{ margin: `${mediumBreakpoint && '0 10px'}` }}
                    value={formValues.lastNamePrefix}
                    onChange={(e) =>
                        setFieldValue('lastNamePrefix', e.target.value)
                    }
                />
                <TextField
                    required
                    id="lastName"
                    label="Achternaam"
                    value={formValues.lastName}
                    onChange={(e) => setFieldValue('lastName', e.target.value)}
                />
            </Row>
        </>
    );
};
